/**
 * Viewport widths at which the Vuetify breakpoints begin (default thresholds,
 * with the 16px desktop scrollbar already subtracted for lg and xl). Use these
 * instead of raw pixel strings wherever a width is passed to a component
 * (side card width, dialog width, etc.) so custom widths stay aligned with
 * the Vuetify grid system.
 *
 * @see https://v2.vuetifyjs.com/en/features/breakpoints/
 */
export enum VuetifyBreakpointEnum {
  SM = "600px",
  MD = "960px",
  LG = "1264px",
  XL = "1904px"
}
